
import { Dispatch, SetStateAction } from 'react';
import { KaziModal } from './Kazi/KaziModal';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../Redux/store';
import { setShowDeactivatedModal } from '../Redux/slices/GlobalModalSlice';
import { useActivateClientMutation } from '../Redux/api/clientApi';
import { useActivateTalentMutation } from '../Redux/api/talentApi';
import { useUser } from '../Hooks/useUser';
import { ProfileType } from '../Types/General';
import { useToast } from '../Hooks/useToast';
import { KaziButton } from './Kazi/KaziButton';

interface DeactivatedModalProps {}
export const DeactivatedModal = ({}:DeactivatedModalProps ) => {
    /* ******************** Hooks ******************** */
    const { type, locator } = useUser();
    const { showToast } = useToast();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [activateClient, {isLoading: clientActivating}] = useActivateClientMutation();
    const [activateTalent, {isLoading: talentActivating}] = useActivateTalentMutation();
    /* ******************** Variables ******************** */
    const open = useAppSelector( state => state.GlobalModal.showDeactivatedModal);
    const isActivating = clientActivating || talentActivating;
    /* ******************** Functions ******************** */
    const handleClose = () => {
        dispatch(setShowDeactivatedModal(false));
        navigate(-1);
    }
    const handleReactivate = () => {
        if (type === ProfileType.Client) {
            activateClient(locator!)
            .unwrap()
            .then(() => {
                dispatch(setShowDeactivatedModal(false));
                showToast({
                    text: 'Account Reactivated'
                })
            })
            .catch((err) => {
                console.error("Error occured while activating client: ", err)
                showToast({
                    text: 'Unable to Reactivate the Account',
                    variant: 'error'
                })
            })
        }

        if (type === ProfileType.Talent) {
            activateTalent(locator!)
            .unwrap()
            .then(() => {
                dispatch(setShowDeactivatedModal(false));
                showToast({
                    text: 'Account Reactivated'
                })
            })
            .catch((err) => {
                console.error("Error occured while activating talent: ", err)
                showToast({
                    text: 'Unable to Reactivate the Account',
                    variant: 'error'
                })
            })

        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title='Your account is Deactivated'
            content={
                <>
                    <Typography>Reactivate your account to access this page</Typography>
                </>
            }
            actions={[
                <Button variant='outlined' onClick={handleClose}>Go back</Button>,
                <KaziButton 
                    variant='contained' 
                    onClick={handleReactivate}
                    text='Reactivate Account'
                    loading={{
                        isLoading: isActivating,
                        loadingText: "Reactivating Account...",
                        color: "secondary"
                    }}
                />
            ]}
        />
    )
}